import api from '@/api/api';

export default {

  namespaced: true,

  state: {
    vecoin: [],
    totalesVecoin: [],
  },
  mutations: {

    getVecoin(state, datos) {
      state.vecoin = datos;
    },

    getTotalesVecoin(state, datos) {
      state.totalesVecoin = datos;
    },
    
    destroyVecoin(state) {
      state.vecoin = [];
    },
  },
  actions: {
    async getVecoin({
      commit,
    },vec) {
      try {
        const res = await api.getVecoin(vec);
        // console.log(object);
        if (res.data.INFO.cod === '200') {
          commit('getVecoin', res.data.DATOS);
          return [true,res.data.INFO.paginacion.Paginas];
        } return [false];
      } catch (error) {
        return [false, 'errorcarga'];
      }
    },

    async getTotalesVecoin({
      commit,
    },objVec) {
      try {
        const res = await api.getTotalesVecoin(objVec);
        // console.log(object);
        if (res.data.INFO.cod === '200') {
          commit('getTotalesVecoin', res.data.INFO.Totales);
          return [true];
        } return [false];
      } catch (error) {
        return [false, 'errorcarga'];
      }
    },

    async destroyVecoin({ commit }) {
      commit('destroyVecoin');
    },




  },
};
